import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  // URL base para la comunicacion de servicios
  public URL_BASE = environment.baseUrl;

  // nombre de la app
  // public APP_NAME = '';

  // identificador de la app
  public APP_ID = environment.appId;

  // URL de login
  public LOGIN_URL = environment.loginUrl;

  // version de la app
  public APP_VERSION = '';

  //URL para realizar la validacion del token
  public URL_VALIDACION_TOKEN = environment.urlValidacionToken;

  getAppId(): string {
    return this.APP_ID;
  }
}
